/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithRefeItemRequestBuilder, WithRefeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Booking/Verify
 */
export interface VerifyRequestBuilder extends BaseRequestBuilder<VerifyRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Booking.Verify.item collection
     * @param refe Unique identifier of the item
     * @returns {WithRefeItemRequestBuilder}
     */
     byRefe(refe: string) : WithRefeItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const VerifyRequestBuilderUriTemplate = "{+baseurl}/Booking/Verify";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VerifyRequestBuilderNavigationMetadata: Record<Exclude<keyof VerifyRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byRefe: {
        requestsMetadata: WithRefeItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["refe"],
    },
};
/* tslint:enable */
/* eslint-enable */
